import { useQuery } from "@tanstack/react-query";
import { abroadDecisionsApi } from "../../api/abroadLoans";
import { ABROAD_KEY } from "./model";

export const DECISIONS_KEY = [...ABROAD_KEY, "decisions"];

export const approvalsPath = "/loans/abroad/approvals";
export const callApprovalsPath = (callId) => `${approvalsPath}/${callId}`;

// Past the award list: awards on their way through the DG and the Minister, and the reserves who may be promoted
export const DECIDING_STATES = ["WITH_DG", "WITH_MINISTER", "RETURNED_TO_HEC", "APPROVED", "REJECTED", "RESERVE"];

// Every application past the award list, of one call or all of them, best HEC score first
export const useDecisions = (callId) =>
  useQuery({
    queryKey: [...DECISIONS_KEY, callId ?? "all"],
    queryFn: async () => (await abroadDecisionsApi.list(callId ? { callId } : undefined)).data.filter((r) => DECIDING_STATES.includes(r.state)),
  });
